"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptySchema = void 0;
const isEmptySchema = (schema) => {
    // no schema
    if (Object.keys(schema || {}).length === 0) {
        return true;
    }
    // object schema with no properties
    // don't bother digging past the first level, if the developer is going to put nested objects and null fields
    // just display them.
    if ((!schema?.type || schema.type === 'object') &&
        Object.keys(schema?.properties || {}).length === 0 &&
        !schema?.oneOf &&
        !schema?.anyOf &&
        !schema?.allOf) {
        return true;
    }
    // kinda dodgy but assume we have a schema otherwise
    return false;
};
exports.isEmptySchema = isEmptySchema;
